module.exports = __webpack_public_path__ + "img/bag3.a6a8c80e.svg";